import moment from 'moment';

export default {
	columns: [
		{ isSortable: true, key: 'orderID', label: 'Order ID', initialSort: true, initialSortDirection: 'desc' },
		{ isSortable: false, key: 'type', label: 'Type' },
		{ isSortable: true, key: 'registrationtime', label: 'Time' },
		{ isSortable: true, key: 'restaurantName', label: 'Restaurant' },
		{ isSortable: false, key: 'address', label: 'Address' },
		{ isSortable: false, key: 'paymentType', label: 'Payment' },
		{ isSortable: true, key: 'total', label: 'Invoice' },
		{ isSortable: true, key: 'status', label: 'Status' },
	],
	status: [
		{ title: 'all', propValue: '', propKey: 'totalOrders', timeProp: '' },
		{ title: 'pending', propValue: 'PENDING', propKey: 'pending', timeProp: 'lastDatePending' },
		{ title: 'accepted', propValue: 'ACCEPTED', propKey: 'accepted', timeProp: 'lastDateAccepted' },
		{ title: 'cooked', propValue: 'COOKED', propKey: 'cooked', timeProp: 'lastDateCooked' },
		{
			title: 'accepted_to_pick_up',
			propValue: 'ACCEPTED_TO_PICK_UP',
			propKey: 'accepted_to_pick_up',
			timeProp: 'lastDateAcceptedToPickUp',
		},
		{
			title: 'in_restaurant',
			propValue: 'IN_RESTAURANT',
			propKey: 'in_restaurant',
			timeProp: 'lastDateInRestaurant',
		},
		{ title: 'collected', propValue: 'COLLECTED', propKey: 'collected', timeProp: 'lastDateCollected' },
		{ title: 'delivered', propValue: 'DELIVERED', propKey: 'delivered', timeProp: 'lastDateDelivered' },
		{ title: 'rejected', propValue: 'REJECTED', propKey: 'rejected', timeProp: 'lastDateRejected' },
		{ title: 'Credit Card', propValue: 'CREDIT_CARD', propKey: 'totalOrdersWithCardPayment' },
		{ title: 'Cashless Value', propValue: 'CASHLESS_VALUE', propKey: 'totalCashlessOrdersValue', price: true },
	],
	statusForCookingTime: [
		{ title: 'all', propValue: '', propKey: 'totalOrders', timeProp: '' },
		{ title: 'pending_new', propValue: 'PENDING', propKey: 'pending', timeProp: 'lastDatePending' },
		{ title: 'accepted_new', propValue: 'ACCEPTED', propKey: 'accepted', timeProp: 'lastDateAccepted' },
		{ title: 'cooked_new', propValue: 'COOKED', propKey: 'cooked', timeProp: 'lastDateCooked' },
		{ title: 'collected_new', propValue: 'COLLECTED', propKey: 'collected', timeProp: 'lastDateCollected' },
		{ title: 'delivered', propValue: 'DELIVERED', propKey: 'delivered', timeProp: 'lastDateDelivered' },
		{ title: 'rejected', propValue: 'REJECTED', propKey: 'rejected', timeProp: 'lastDateRejected' },
		{ title: 'Credit Card', propValue: 'CREDIT_CARD', propKey: 'totalOrdersWithCardPayment' },
		{ title: 'Cashless Value', propValue: 'CASHLESS_VALUE', propKey: 'totalCashlessOrdersValue', price: true },
	],
	statusShort: [
		{ title: 'All', propValue: '', propKey: 'totalOrders', timeProp: '' },
		{ title: 'Pending', propValue: 'PENDING', propKey: 'pending', timeProp: 'lastDatePending' },
		{ title: 'Accepted', propValue: 'ACCEPTED', propKey: 'accepted', timeProp: 'lastDateAccepted' },
		{ title: 'Cooked', propValue: 'COOKED', propKey: 'cooked', timeProp: 'lastDateCooked' },
		{ title: 'Delivered', propValue: 'DELIVERED', propKey: 'delivered', timeProp: 'lastDateDelivered' },
		{ title: 'Rejected', propValue: 'REJECTED', propKey: 'rejected', timeProp: 'lastDateRejected' },
		{ title: 'Credit Card', propValue: 'CREDIT_CARD', propKey: 'totalOrdersWithCardPayment' },
		{ title: 'Cashless Value', propValue: 'CASHLESS_VALUE', propKey: 'totalCashlessOrdersValue', price: true },
	],
	statusCompany: [
		{ title: 'All', propValue: '', propKey: 'totalOrders', timeProp: '' },
		{ title: 'Pending', propValue: 'PENDING', propKey: 'pending', timeProp: 'lastDatePending' },
		{ title: 'Accepted', propValue: 'ACCEPTED', propKey: 'accepted', timeProp: 'lastDateAccepted' },
		{ title: 'Cooked', propValue: 'COOKED', propKey: 'cooked', timeProp: 'lastDateCooked' },
		{ title: 'Delivered', propValue: 'DELIVERED', propKey: 'delivered', timeProp: 'lastDateDelivered' },
		{ title: 'Rejected', propValue: 'REJECTED', propKey: 'rejected', timeProp: 'lastDateRejected' },
	],
	companyOrdersColumns: [
		{ isSortable: true, key: 'orderID', label: 'orderId', initialSort: true, initialSortDirection: 'desc' },
		{ isSortable: true, key: 'restaurantName', label: 'restaurant' },
		{ isSortable: true, key: 'customer', label: 'Name' },
		{ isSortable: true, key: 'total', label: 'invoice' },
		{ isSortable: true, key: 'registrationtime', label: 'time' },
		{ isSortable: true, key: 'status', label: 'status' },
	],

	defaultFilters: {
		fullBody: false,
		loadLastStatusDates: true,
		loadNewCustomerStatus: true,
		reportTypeId: 10,
		orderActive: 1,
		limit: 50,
		offset: 0,
		orderStatus: '',
		isForDriver: false,
		startDate: moment().format('YYYY-MM-DD'),
		endDate: moment()
			.add(1, 'day')
			.format('YYYY-MM-DD'),
		cityId: -1,
		takeaway: -1,
		paymentType: null,
		withCreditCardOrCashless: -1,
		includeCompletedOrders: 0,
	},
	defaultCompanyOrdersFilters: {
		limit: 50,
		offset: 0,
		startDate: moment().format('YYYY-MM-DD'),
		endDate: moment()
			.add(1, 'day')
			.format('YYYY-MM-DD'),
	},
	ordersDriverValues: ['ACTIVE DRIVER', 'OFFLINE DRIVER'],
	driverColumns: [
		{ isSortable: true, key: 'courierId', label: 'ID' },
		{ isSortable: false, key: 'driver', label: 'Driver' },
		{ isSortable: false, key: 'basket', label: 'Basket' },
		{ isSortable: false, key: 'pickup', label: 'Pickup' },
		{ isSortable: false, key: 'inRestaurant', label: 'In Restaurant' },
		{ isSortable: false, key: 'collect', label: 'Collect' },
		{ isSortable: true, key: 'ordersNo', label: 'Total Orders', initialSort: true, initialSortDirection: 'desc' },
		{ isSortable: true, key: 'transportCost', label: 'Transport Cost' },
		{ isSortable: true, key: 'totalHours', label: 'Hours' },
	],
	driverMiniColumns: [
		{ key: 'driver', label: 'Driver' },
		{ key: 'pickup', label: 'Pickup' },
		{ key: 'inRestaurant', label: 'In Restaurant' },
		{ key: 'collect', label: 'Collect' },
	],
	driverTinyColumns: [
		{ key: 'driver', label: 'Driver', class: 'flex-1' },
		{ skipSearch: true, key: 'pickup', label: 'P', class: 'w-5 mr-1' },
		{ skipSearch: true, key: 'inRestaurant', label: 'IR', class: 'w-5 mr-1' },
		{ skipSearch: true, key: 'collect', label: 'C', class: 'w-5 mr-1' },
	],
	timelineSteps: [
		{ step: 1, dateProp: 'lastDatePending', title: 'Pending', status: 'PENDING' },
		{ step: 2, dateProp: 'lastDateAccepted', title: 'Accepted', status: 'ACCEPTED' },
		{ step: 3, dateProp: 'lastDateCooked', title: 'Cooked', status: 'COOKED' },
		{ step: 4, dateProp: 'lastDateAcceptedToPickUp', title: 'Picked up', status: 'ACCEPTED_TO_PICK_UP' },
		{ step: 5, dateProp: 'lastDateInRestaurant', title: 'In restaurant', status: 'IN_RESTAURANT' },
		{ step: 6, dateProp: 'lastDateCollected', title: 'Collected', status: 'COLLECTED' },
		{ step: 7, dateProp: 'lastDateDelivered', title: 'Delivered', status: 'DELIVERED' },
		{ step: 8, dateProp: 'lastDateRejected', title: 'Rejected', status: 'REJECTED' },
	],
	timelineStepsNew: [
		{ step: 1, dateProp: 'lastDatePending', title: 'Pending', status: 'PENDING' },
		{ step: 2, dateProp: 'lastDateAccepted', title: 'Accepted', status: 'ACCEPTED' },
		{ step: 3, dateProp: 'lastDateAcceptedToPickUp', title: 'Picked up', status: 'ACCEPTED_TO_PICK_UP' },
		{ step: 4, dateProp: 'lastDateCooked', title: 'Cooked', status: 'COOKED' },
		{ step: 5, dateProp: 'lastDateInRestaurant', title: 'In restaurant', status: 'IN_RESTAURANT' },
		{ step: 6, dateProp: 'lastDateCollected', title: 'Collected', status: 'COLLECTED' },
		{ step: 7, dateProp: 'lastDateDelivered', title: 'Delivered', status: 'DELIVERED' },
		{ step: 8, dateProp: 'lastDateRejected', title: 'Rejected', status: 'REJECTED' },
	],
	addressColumns: [
		{ key: 'id', label: 'Id' },
		{ key: 'addressStreet', label: 'Street' },
		{ key: 'addressDetails', label: 'Details' },
		{ key: 'active', label: 'Is Active' },
		{ key: 'primary', label: 'Is Primary' },
	],
	deliveryTypesOptions: [
		{ value: -1, label: 'All' },
		{ value: 0, label: 'Delivery' },
		{ value: 1, label: 'Takeaway' },
	],
	discountColumns: [
		{ key: 'title', label: 'title' },
		{ key: 'couponCode', label: 'couponCode' },
		{ key: 'percentage', label: 'is_percentage' },
		{ key: 'discount', label: 'discount' },
		{ key: 'minimumOrder', label: 'minimumOrder' },
		{ key: 'customersNo', label: 'customersNo' },
		{ key: 'startDate', label: 'startDate' },
		{ key: 'endDate', label: 'endDate' },
		{ key: 'status', label: 'status' },
	],
};
